import axios from './axiosConfig';

export function getLangBasedDomain() {
    return axios.get('/api/v1/app-settings')
        .then(function (response) {
            // handle success
            return response.data;
        })
        .catch(function (error) {
            // handle error
            return error;
        });
}
